module.exports = __webpack_public_path__ + "static/img/12.82c9981.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/sp/12.png
// module id = dJvr
// module chunks = 0